import React from 'react'
import { PortableText } from '@portabletext/react'
import { urlFor } from './imageUrl'

const renderWithLineBreaks = (children) => {
  const parts = []
  React.Children.toArray(children).forEach((child, idx) => {
    if (typeof child === 'string' && child.includes('\n')) {
      const split = child.split('\n')
      split.forEach((segment, i) => {
        if (segment) parts.push(segment)
        if (i < split.length - 1) parts.push(<br key={`br-${idx}-${i}`} />)
      })
    } else {
      parts.push(child)
    }
  })
  return parts
}

const createComponents = ({ wrapClassName } = {}) => ({
  marks: {
    link: ({ value, children }) => {
      const href = value?.href || ''
      const isExternal = href.startsWith('http')
      return (
        <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noreferrer' : undefined}>
          {children}
        </a>
      )
    },
    strong: ({ children }) => <strong className="pt-strong">{children}</strong>,
  },
  types: {
    image: ({ value }) => {
      const url = urlFor(value)?.toString()
      if (!url) return null
      return <img src={url} alt={value?.alt || ''} style={{ maxWidth: '100%' }} />
    },
  },
  block: {
    h2: ({ children }) => <h2 className="pt-h2">{renderWithLineBreaks(children)}</h2>,
    h3: ({ children }) => <h3 className="pt-h3">{renderWithLineBreaks(children)}</h3>,
    h3Large: ({ children }) => <h3 className="pt-h3 pt-h3-large">{renderWithLineBreaks(children)}</h3>,
    h4: ({ children }) => <h4 className="pt-h4">{renderWithLineBreaks(children)}</h4>,
    h5: ({ children }) => <h5 className="pt-h5">{renderWithLineBreaks(children)}</h5>,
    normal: ({ children, index, value }) => {
      // Special case: About-me page expects specific classes even when content comes from Sanity.
      if (wrapClassName === 'about-me') {
        const plainText = (value?.children || []).map((c) => c?.text || '').join('')

        // First paragraph = intro
        if (index === 0) {
          return <p className="pt-p about-me-intro">{children}</p>
        }

        // Any paragraph starting with "Kontakt:" = contact line
        if (/^\s*Kontakt\s*:/i.test(plainText)) {
          return <p className="pt-p about-me-contact">{children}</p>
        }
      }

      return <p className="pt-p">{children}</p>
    },
  },
})

export default function PT({ value, wrapClassName }) {
  if (!value) return null
  const components = createComponents({ wrapClassName })

  return (
    <div className="portabletext">
      {wrapClassName ? (
        <div className={wrapClassName}>
          <PortableText value={value} components={components} />
        </div>
      ) : (
        <PortableText value={value} components={components} />
      )}
    </div>
  )
}

